import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home, Video } from 'lucide-react';
import AuthContext from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import VideoManager from '@/components/VideoManager';

const SECTIONS = [
  { id: 'probound', name: 'ProBound', color: '#2F5E96' },
  { id: 'proepoxy', name: 'ProEpoxy', color: '#7A0B7A' },
  { id: 'prodecor', name: 'ProDecor', color: '#D4A24B' },
  { id: 'protraining', name: 'ProTraining', color: '#D35400' },
];

export default function StaffVideos() {
  const navigate = useNavigate();
  const { isStaff } = useContext(AuthContext);
  const [section, setSection] = useState('probound');

  useEffect(() => { if (!isStaff) navigate('/'); }, [isStaff, navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="text-white" style={{ background: 'linear-gradient(135deg, #0B0B0E 0%, #7A0B7A 75%)', borderBottom: '3px solid #D4A24B' }}>
        <div className="max-w-[1400px] mx-auto px-3 sm:px-4 py-4 flex items-center gap-3">
          <button onClick={() => navigate('/staff')} className="p-2 hover:bg-white/10 rounded-lg" data-testid="sv-back" aria-label="Back"><ArrowLeft className="w-5 h-5" /></button>
          <h1 className="flex-1 text-base sm:text-2xl font-bold flex items-center gap-2 truncate">
            <Video className="w-5 h-5 sm:w-6 sm:h-6" style={{ color: '#D4A24B' }} /> Videos
          </h1>
          <Button onClick={() => navigate('/staff')} variant="outline" size="sm" className="bg-white/10 border-white/30 text-white hover:bg-white/20"><Home className="w-4 h-4 sm:mr-1" /><span className="hidden sm:inline">Staff</span></Button>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-3 sm:px-4 py-5">
        <div className="flex gap-2 mb-5 flex-wrap">
          {SECTIONS.map((s) => (
            <button
              key={s.id}
              onClick={() => setSection(s.id)}
              data-testid={`sv-section-${s.id}`}
              className={`px-4 py-2 rounded-xl font-medium text-sm transition-colors ${section === s.id ? 'text-white' : 'bg-white text-gray-600 hover:bg-gray-100 border'}`}
              style={section === s.id ? { backgroundColor: s.color } : {}}
            >
              {s.name}
            </button>
          ))}
        </div>
        <div className="bg-white rounded-2xl shadow-sm p-5">
          <VideoManager section={section} key={section} />
        </div>
      </div>
    </div>
  );
}
